<template>
  <div class="risk-dialog">
    <el-dialog
      class="hidden-detail-dlialog"
      :visible.sync="showDialog"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-press-escape="false"
      @close="close"
      style="padding:0"
    >
      <div class="content">
        <div class="hidden-close" @click="close">
          关闭
        </div>
        <div class="content-title">
          <img
            v-if="searchParams.hiddenDangerClass"
            :src="
              require('@/assets/img/hiddenIcon/hidden-' +
                searchParams.hiddenDangerClass +
                '.png')
            "
            alt=""
          />
          <span
            v-if="searchParams.hiddenDangerClass == 1"
            style="color:#ffff00"
          >
            一般隐患
          </span>
          <span v-else style="color:#ff0000">
            重大隐患
          </span>
        </div>
        <div class="table-wrapper">
          <el-table
            :row-style="getRowClass"
            :cell-style="tableCellStyle"
            :header-row-style="getRowClass"
            :header-cell-style="getRowClass"
            :data="tableData"
            height="520px"
            border
            v-loading="tableLoading"
          >
            <el-table-column label="整改前图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.hiddenDangerImgUrl"
                  style="width: 60px; height: 60px"
                  :src="
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgUrl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgUrl
                  ]"
                >
                </el-image>
                <el-image
                  style="width: 60px; height: 60px"
                  v-else
                  :src="require('@/assets/img/noData/no_img.png')"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="整改后图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.hiddenDangerImgAfterurl"
                  style="width: 60px; height: 60px"
                  :src="
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgAfterurl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgAfterurl
                  ]"
                >
                </el-image>
                <el-image
                  style="width: 60px; height: 60px"
                  v-else
                  :src="require('@/assets/img/noData/no_img.png')"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              label="隐患等级"
              width="80px"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ hiddenDangerLeve[scope.row.hiddenDangerClass].nameOne }}
              </template></el-table-column
            >
            <el-table-column
              label="隐患来源"
              width="100px"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ hiddenDangerSource[scope.row.hiddenDangerFrom].nameOne }}
              </template></el-table-column
            >
            <el-table-column
              label="隐患描述"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerDescribe"
            ></el-table-column>
            <el-table-column
              label="隐患类型"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerClassifyName"
            ></el-table-column>
            <el-table-column
              label="上报人昵称"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="reportUserName"
            ></el-table-column>
            <el-table-column
              label="处理人昵称"
              width="100px"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.disposeUserName || "" }}
              </template></el-table-column
            >
            <el-table-column
              label="负责人昵称"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="principalName"
            ></el-table-column>
            <el-table-column
              label="是否已处理"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="treatmentState"
              ><template slot-scope="scope">
                {{ processingStatus[scope.row.treatmentState].nameOne }}
              </template></el-table-column
            >
            <el-table-column
              label="上报时间"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="addTime"
            >
              <template slot-scope="scope">
                {{ $Common.dateFormatDate(scope.row.addTime) }}
              </template>
            </el-table-column>
            <el-table-column
              label="隐患状态"
              width="80px"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ hiddenDangerStatus[scope.row.hiddenDangerStatus].nameOne }}
              </template></el-table-column
            >
            <el-table-column
              label="隐患地点"
              width="100px"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerPosition"
            ></el-table-column>
            <el-table-column
              label="要求完成时间"
              width="100px"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.completionTime }}小时
              </template></el-table-column
            >
          </el-table>
          <el-pagination
            class="pagination"
            :page-size="params.pageSize"
            :pager-count="5"
            :current-page="params.pageNum"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "hiddenDialog",
  props: {
    show: {
      type: Boolean
    },
    searchParams: {
      type: Object
    }
  },
  data() {
    return {
      params: {
        schoolId: "", //学校id
        hiddenDangerClass: "", //隐患类型
        pageNum: 1,
        pageSize: 20
      },
      showDialog: false,
      tableData: [],
      tableLoading: false,
      total: 0
    };
  },
  created() {},
  mounted() {},
  methods: {
    async getStandingBooks() {
      this.tableLoading = true;
      let req = Object.assign({}, this.params);
      let res = await this.$Http.getHiddenDangers(req);
      this.tableLoading = false;
      if (res.code == 200) {
        if (res.data) {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        } else {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        }
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 分页点击
    currentChange(val) {
      this.params.pageNum = val;
      this.getStandingBooks();
    },
    close() {
      this.$emit("close");
    },
    // 修改 table cell边框的背景色
    tableCellStyle() {
      return "border-color: #868686;";
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#3f5c6d2c;color:#c4cdff";
    }
  },
  watch: {
    show: function(nval) {
      if (nval) {
        this.params = Object.assign({}, this.searchParams);
        this.params.pageNum = 1;
        this.params.pageSize = 20;
        this.total = 0;
        this.getStandingBooks();
      }
      this.showDialog = nval;
    }
  },
  computed: {
    riskLevelList() {
      return this.$store.state.select.riskLevel.map((item) => {
        return { color: item.color, levelName: item.levelNameOne };
      });
    },
    // 隐患等级
    hiddenDangerLeve() {
      return this.$store.state.select.hiddenDangerLevel;
    },
    // 隐患来源
    hiddenDangerSource() {
      return this.$store.state.select.hiddenDangerSource;
    },
    // 隐患类型
    hiddenDangerType() {
      return this.$store.state.select.hiddenDangerType;
    },
    // 处理状态
    processingStatus() {
      return this.$store.state.select.processingStatus;
    },
    // 隐患状态
    hiddenDangerStatus() {
      return this.$store.state.select.hiddenDangerStatus;
    }
  }
};
</script>
<style scoped lang="scss">
.content {
  padding-top: 12px;
  width: 100%;
  height: 100%;
  // 已修改
  background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center no-repeat;
  background-size: 100% 100%;
    padding: 20px 46px 10px 34px;
  position: relative;
  .hidden-close {
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    line-height: 25px;
    letter-spacing: 1px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .content-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 54px;
      height: 54px;
    }
    span {
      margin-left: 16px;
      font-size: 22px;
    }
  }
}
.pagination {
  /deep/ &.el-pagination {
  margin: 10px;
  float: right;
  background-color: transparent;
    .el-pagination__total {
      color: #c4f0ff
    }
    button{
      width: 28px;
      min-width: 28px;
      border-radius: 6px;
      background: transparent;
      border: 1px solid rgba(44,166,252,1);
      box-shadow: inset 0px 1px 16px 0px rgba(65, 77, 161, 0.5);
      &:hover {
        background: rgba(44,166,252,1);
      }
      &:disabled {
        background: transparent;
        cursor: default;
      }
      .el-icon {
        color: #c4f0ff;
        &.el-icon-arrow-right {
          position: relative;
          left: -4px;
        }
      }
    }
    .el-pager {
      li {
        color: rgba(255, 255, 255, 0.6);
        background: transparent;
        &:hover,
        &.active {
          color: #fff;
        }
      }
    }
  }
}
.table-wrapper /deep/ .el-table--fit {
  padding: 0px;
}
.table-wrapper /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent;
}

.table-wrapper /deep/ .el-table tr {
  background-color: transparent !important;
}

.table-wrapper /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
  background-color: transparent;
  color: #c4cdff;
}
.risk-dialog {
  /deep/ .hidden-detail-dlialog {
    .el-dialog {
      width: 1550px;
      height: 740px;
      background: transparent;
    }
  }
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
</style>
